export type StepStatus = 'pending' | 'completed' | 'active' | 'incidence';

export enum ValidationStep {
  DOCUMENT_NUMBER_VALIDATION = 'document_number_validation',
  DOCUMENT_ID_VALIDATION = 'document_id_validation',
  VIDEO_ID_VALIDATION = 'video_id_validation',
  BANK_ACCOUNT_VALIDATION = 'bank_account_validation',
  INCOME_VALIDATION = 'income_validation',
  CONFIRMATION = 'confirmation',
}

export type ValidationStepStatus = {
  status: StepStatus;
  step: ValidationStep;
};
